import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import IconButton from '@mui/material/IconButton'
import styled from 'styled-components';
import {
  ModalInner
} from '../';
import { StanceCard } from '../StanceCard';
import Typography from '@mui/material/Typography';


const DetailContentModal = ({
  onClose,
  stance,
  contentComponent
}) => {
  const titleForSource = (source) => {
    if(source.sourceType === 'website') return 'Candidate website';
    else if(source.sourceType === 'questionnaire') return 'Branch questionnaire';
    else return source?.title || 'Article';
  }

  // Support both stance.sources (for backward compatibility) and sources prop
  const sourcesToUse = stance?.sources;
  const numSources = (sourcesToUse && Array.isArray(sourcesToUse))
    ? sourcesToUse.length
    : (Boolean(sourcesToUse) ? 1 : 0);
    
  const returnSource = (source, key, index) => {
    const title = titleForSource(source)
    // For backward compatibility: use source.directQuote if available,
    // otherwise fall back to stance.directQuote if there's only one source
    const directQuote = source.directQuote || (numSources === 1 && stance?.directQuote ? stance.directQuote : null);
    
    return (
      <React.Fragment key={key}>
        <SourceLink href={source.url} target="_blank" rel="noopener noreferrer" role='link' aria-label={`Link to ${title} source`}>
          <SourceRow>
            {
              Boolean(directQuote) &&
              <div style={{ margin: '6px 0 0'}}>
                <Typography variant='body1' color='textPrimary' style={{ margin: '0' }}>
                  &quot;...{directQuote.slice(0,200)}...&quot;
                </Typography>
              </div>
            }
            <div style={{ display: 'flex', gap: '0px', justifyContent: 'flex-start', alignItems: 'center'}}>
              <Typography color='textPrimary' style={{textDecoration: 'underline', fontWeight: 'bolder', letterSpacing: '0.5px', opacity: 0.8}}>{title}</Typography>
              <IconWrapper aria-hidden='true'>
                <ArrowOutwardIcon style={{ fontSize: '16px' }}/>
              </IconWrapper>
            </div>
          </SourceRow>
        </SourceLink>
      </React.Fragment>
    )
  }

  // Default to StanceCard if no contentComponent is provided
  const renderContent = contentComponent || (() => (
    <StanceCard
      stance={stance}
      showActions={false}
      style={{ marginBottom: '24px', marginTop: '8px' }}
    />
  ));

  const contentElement = typeof renderContent === 'function' ? renderContent() : renderContent;
  const clonedContent = React.isValidElement(contentElement)
    ? React.cloneElement(contentElement, {
        style: {
          ...(contentElement.props?.style || {}),
          flexShrink: 0
        }
      })
    : contentElement;

  return (
    <Wrapper onClose={onClose}>
      {clonedContent}
      <Typography variant='overline' color='textPrimary' style={{ margin: '18px 0px -6px'}}>
        Sources
      </Typography>
      {
        Boolean(sourcesToUse) &&
        Array.isArray(sourcesToUse) ?
          (sourcesToUse || []).map((source, i) => returnSource(source, `${source.sourceType}-${i}`, i))
          : returnSource(sourcesToUse, sourcesToUse.sourceType, 0)
      }
    </Wrapper>
  );
}


const Wrapper = styled(ModalInner)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 24px 60px 24px 36px;
  min-height: 124px;
  width: calc(100% - 24px * 2);

  /* mobile */
  @media(max-width: 480px) {
    padding: 24px 24px 24px;
  }

  @media(min-width: 480px) {
    max-width: 500px;
  }

`

const SourceLink = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`

const SourceRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 0;
  gap: 0px;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #878787;
  opacity: 0.5;
`

const IconWrapper = styled(IconButton)`
cursor: pointer
`

export { DetailContentModal };
